import Vue from 'vue';
import Router from 'vue-router';
import { createSandbox } from 'vue-kindergarten';

import store from '@/store';
import child from '@/child';

import RouteGoverness from '@/governesses/RouteGoverness';
import ComplexPerimeter from '@/perimeters/complex';
import SourcePerimeter from '@/perimeters/source';
import InvestigatorPerimeter from '@/perimeters/investigator';
import SubjectPerimeter from '@/perimeters/subject';
import SanmerPerimeter from '@/perimeters/sanmer';
import UserPerimeter from '@/perimeters/user';
import ContactPerimeter from '@/perimeters/contact';

Vue.use(Router);

function load(component) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${component}`);
}

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (!savedPosition) {
      return { x: 0, y: 0 };
    }

    return savedPosition;
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: load('subject/SubjectList'),
      meta: {
        perimeter: SubjectPerimeter,
        perimeterAction: 'all'
      }
    },
    {
      path: '/zoeken/:term',
      name: 'home',
      component: load('subject/SubjectList'),
      meta: {
        perimeter: SubjectPerimeter,
        perimeterAction: 'all'
      }
    },
    {
      path: '/opdrachten/:id',
      name: 'subject',
      component: load('subject/SubjectEdit'),
      meta: {
        perimeter: SubjectPerimeter,
        perimeterAction: 'read'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: load('Login'),
      meta: {
        layout: 'LayoutLogin'
      }
    },
    {
      path: '/complexen',
      name: 'complexes',
      component: load('complex/ComplexList'),
      meta: {
        perimeter: ComplexPerimeter,
        perimeterAction: 'all'
      }
    },
    {
      path: '/complexen/nieuw',
      name: 'complex-new',
      component: load('complex/ComplexEdit'),
      meta: {
        perimeter: ComplexPerimeter,
        perimeterAction: 'create'
      }
    },
    {
      path: '/complexen/:id',
      name: 'complex',
      component: load('complex/ComplexEdit'),
      meta: {
        perimeter: ComplexPerimeter,
        perimeterAction: 'read'
      }
    },
    {
      path: '/bronnen',
      name: 'sources',
      component: load('SourceList'),
      meta: {
        perimeter: SourcePerimeter,
        perimeterAction: 'all'
      }
    },
    {
      path: '/onderzoekers',
      name: 'investigators',
      component: load('investigator/InvestigatorList'),
      meta: {
        perimeter: InvestigatorPerimeter,
        perimeterAction: 'all'
      }
    },
    {
      path: '/saneerders',
      name: 'sanmers',
      component: load('sanmer/SanmerList'),
      meta: {
        perimeter: SanmerPerimeter,
        perimeterAction: 'all'
      }
    },
    {
      path: '/saneerders/nieuw',
      name: 'sanmer-new',
      component: load('sanmer/SanmerEdit'),
      meta: {
        perimeter: SanmerPerimeter,
        perimeterAction: 'create'
      }
    },
    {
      path: '/saneerders/:id',
      name: 'sanmer',
      component: load('sanmer/SanmerEdit'),
      meta: {
        perimeter: SanmerPerimeter,
        perimeterAction: 'read'
      }
    },
    {
      path: '/account',
      name: 'account',
      component: load('user/UserProfile')
    },
    {
      path: '/organisaties',
      name: 'organizations',
      component: load('organization/OrganizationList'),
      meta: {
        perimeter: ContactPerimeter,
        perimeterAction: 'all'
      }
    },
    {
      path: '/organisaties/nieuw',
      name: 'organization-new',
      component: load('organization/OrganizationEdit'),
      meta: {
        perimeter: ContactPerimeter,
        perimeterAction: 'create'
      }
    },
    {
      path: '/organisaties/:id',
      name: 'organization',
      component: load('organization/OrganizationEdit'),
      meta: {
        perimeter: ContactPerimeter,
        perimeterAction: 'all'
      }
    },
    {
      path: '/organisaties/:id/klanten/nieuw',
      name: 'user-new',
      component: load('user/UserEdit'),
      meta: {
        perimeter: UserPerimeter,
        perimeterAction: 'create'
      }
    },
    {
      path: '/organisaties/:id/klanten/:user_id',
      name: 'user',
      component: load('user/UserEdit'),
      meta: {
        perimeter: UserPerimeter,
        perimeterAction: 'read'
      }
    }
  ]
});

const protectRoute = (route, to, from, next) => {
  const { meta } = route;
  const { perimeter } = meta;
  const Governess = meta.governess || RouteGoverness;
  const action = meta.perimeterAction || 'read';

  if (perimeter) {
    const sandbox = createSandbox(child(store), {
      governess: new Governess(),
      perimeters: [perimeter]
    });

    const guard = () => sandbox.guard(action, { next });
    return guard();
  }

  return next();
};

router.beforeEach((to, from, next) => {
  to.matched.some(route => {
    if (!child(store) && store.state.auth.isAuthenticated) {
      return store
        .dispatch('auth/refetch')
        .then(() => protectRoute(route, to, from, next))
        .catch(error => console.log(error));
    }

    return protectRoute(route, to, from, next);
  });
});

export default router;
